module.exports = __webpack_public_path__ + "static/media/newLogo.24630a37.png";